export default __webpack_public_path__ + "static/media/pink-following.b4155dab.svg";